"use strict";
// a group of functions that need to be implemented for each backend
//  goal is to provide "shortcuts" during e2e tests
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
require("firebase/auth");
require("firebase/firestore");
var util_1 = require("./util");
function initCurry(store, router, appConfig) {
    function login(user) {
        if (user === void 0) { user = 'rick'; }
        return __awaiter(this, void 0, void 0, function () {
            var credentials, _a, email, password, login;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        switch (user) {
                            case 'rick':
                                credentials = 'rick@devradar.io:sanchez';
                                break;
                            case 'morty':
                                credentials = 'morty@devradar.io:jessica';
                                break;
                        }
                        _a = credentials.split(':'), email = _a[0], password = _a[1];
                        return [4 /*yield*/, app_1.default.auth().signInWithEmailAndPassword(email, password)];
                    case 1:
                        login = _b.sent();
                        return [2 /*return*/, login.user.uid];
                }
            });
        });
    }
    function addBlipToFirestore(radarId, blip) {
        return __awaiter(this, void 0, void 0, function () {
            var nBlip, changes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        nBlip = util_1.cleanBlip(blip);
                        changes = blip.changes;
                        // assign IDs to changes
                        nBlip.changes = changes
                            .map(function (c) {
                            if (!c.id)
                                c.id = util_1.getUUID();
                            return c;
                        })
                            .map(util_1.cleanChange);
                        return [4 /*yield*/, app_1.default.firestore().collection("radars/" + radarId + "/blips").add(nBlip)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function addBlip(blip) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, store.dispatch('blips/addBlip', blip)];
            });
        });
    }
    function dropBlips() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, store.dispatch('blips/setBlips', [])];
            });
        });
    }
    function getRadarIdByUserId(userId) {
        return __awaiter(this, void 0, void 0, function () {
            var retryCount, getSnapshot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retryCount = 9;
                        _a.label = 1;
                    case 1:
                        if (!retryCount) return [3 /*break*/, 4];
                        return [4 /*yield*/, app_1.default.firestore().collection('radars')
                                .where('owner', '==', userId)
                                .limit(3)
                                .get()];
                    case 2:
                        getSnapshot = _a.sent();
                        if (getSnapshot.size > 0) {
                            return [2 /*return*/, getSnapshot.docs[0].id];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, 200); })];
                    case 3:
                        _a.sent();
                        retryCount--;
                        return [3 /*break*/, 1];
                    case 4: throw new Error("Reached max retries while trying to getRadarIdByUserId(" + userId + ")");
                }
            });
        });
    }
    return {
        login: login,
        addBlip: addBlip,
        addBlipToFirestore: addBlipToFirestore,
        dropBlips: dropBlips,
        getRadarIdByUserId: getRadarIdByUserId
    };
}
exports.default = initCurry;
